// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"43b92ebb","911":"6f4191c5"}[chunkId] + ".chunk.css";
};